import { useEffect } from "react";
import Lenis from "lenis";

// Expose Lenis instance for other components (e.g., ScrollToTop)
if (typeof window !== "undefined") {
  window.__lenis = window.__lenis || null;
}

export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });

    if (typeof window !== "undefined") window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      if (typeof window !== "undefined") window.__lenis = null;
    };
  }, []);

  return null;
}
